import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListItem, SelectableListItem } from '../model/list';

@Component({
  selector: 'app-nav-list-item',
  templateUrl: './nav-list-item.component.html',
  styleUrls: ['./nav-list-item.component.css', '../../app.component.scss']
})
export class NavListItemComponent implements OnInit {

  @Input() data: SelectableListItem
  displayDelete = false
  displayEditPolygon = false
  withoutSub: boolean = true

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.data.subtitle) this.withoutSub = false
    this.displayDelete = this.data.displayDelete ? true : false
    this.displayEditPolygon = this.data.displayEditPolygon ? true : false
  }

  onClick() {
    this.data.onClick()
  }

  delete() {
    this.data.onDeleteListItem(this.data.data.identifier)
  }

  polygonEditor() {
    this.router.navigate([this.data.data.identifier + '/polygon'], {relativeTo: this.route})
  }
}
